
import { UserAccountKey } from '../../types';

export const userAccount: Record<UserAccountKey, string> = {
  freePlan: 'Free Plan',
  plays: 'plays',
  upgrade: 'Upgrade',
  popularPosts: 'Popular Posts',
  viewAll: 'View All',
  trending: 'Trending',
  newest: 'Newest',
  following: 'Following',
  favorites: 'Favorites',
  yourVideos: 'Your Videos',
  subscriptions: 'Subscriptions',
  library: 'Library',
  history: 'History',
  watchLater: 'Watch Later',
  playlists: 'Playlists',
  channels: 'Channels',
  transactions: 'Transactions',
  earnings: 'Earnings',
  payouts: 'Payouts',
};
